/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderTagWithNetSalesAndQuantity } from './OrderTagWithNetSalesAndQuantity';
import {
    OrderTagWithNetSalesAndQuantityFromJSON,
    OrderTagWithNetSalesAndQuantityFromJSONTyped,
    OrderTagWithNetSalesAndQuantityToJSON,
    OrderTagWithNetSalesAndQuantityToJSONTyped,
} from './OrderTagWithNetSalesAndQuantity';

/**
 * 
 * @export
 * @interface MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse
 */
export interface MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse {
    /**
     * 
     * @type {Array<OrderTagWithNetSalesAndQuantity>}
     * @memberof MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse
     */
    data: Array<OrderTagWithNetSalesAndQuantity>;
}

/**
 * Check if a given object implements the MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse interface.
 */
export function instanceOfMenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse(value: object): value is MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponseFromJSON(json: any): MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse {
    return MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponseFromJSONTyped(json, false);
}

export function MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(OrderTagWithNetSalesAndQuantityFromJSON)),
    };
}

export function MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponseToJSON(json: any): MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse {
    return MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponseToJSONTyped(json, false);
}

export function MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponseToJSONTyped(value?: MenuMixBusinessProductOrderTagsWithNetSalesAndQuantityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(OrderTagWithNetSalesAndQuantityToJSON)),
    };
}

